import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { LucideIcon as Icon } from 'lucide-react';
import React from 'react';
import { BetaBadge } from '../../../../../../components/BetaBadge';
import { useTranslation } from '../../../../../../i18next';

const TaskSettingsOverviewSectionContainer = styled('div')<{
  divider?: boolean;
}>((p) => ({
  marginBottom: p.theme.spacing(3),
  paddingBottom: p.divider ? p.theme.spacing(3) : undefined,
  borderBottom: p.divider ? p.theme.custom.border.standard : undefined,
  cursor: p.onClick ? 'pointer' : undefined
}));

const TaskSettingsOverviewSectionHeader = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: p.theme.spacing(),
  marginBottom: p.theme.spacing()
}));

const TaskSettingsOverviewSectionHeading = styled('div')((p) => ({
  display: 'flex',
  alignItems: 'center',
  gap: p.theme.spacing(0.75)
}));

const TaskSettingsOverviewSectionBody = styled('div')((p) => ({}));

export const TaskSettingsOverviewSection: React.FC<{
  icon?: Icon;
  title: string;
  divider?: boolean;
  onEdit?: () => void;
  beta?: boolean;
  sayViewNotEdit?: boolean;
  onlyTriggerClickOnHeader?: boolean;
}> = ({
  icon,
  title,
  divider,
  onEdit,
  beta,
  sayViewNotEdit,
  children,
  onlyTriggerClickOnHeader
}) => {
  const { t } = useTranslation();
  return (
    <TaskSettingsOverviewSectionContainer
      divider={divider}
      role={onEdit && !onlyTriggerClickOnHeader ? 'button' : undefined}
      onClick={onlyTriggerClickOnHeader ? undefined : onEdit}
    >
      <TaskSettingsOverviewSectionHeader
        role={onEdit && onlyTriggerClickOnHeader ? 'button' : undefined}
        onClick={onlyTriggerClickOnHeader ? onEdit : undefined}
      >
        <TaskSettingsOverviewSectionHeading>
          {icon && React.createElement(icon, { size: 16 })}
          <Typography component="h6" variant="h6">
            {title}
          </Typography>
          {beta && <BetaBadge />}
        </TaskSettingsOverviewSectionHeading>
        {onEdit && (
          <Button variant="text" color="primary" size="small">
            {sayViewNotEdit ? t('View') : t('Edit')}
          </Button>
        )}
      </TaskSettingsOverviewSectionHeader>
      <TaskSettingsOverviewSectionBody>
        {children}
      </TaskSettingsOverviewSectionBody>
    </TaskSettingsOverviewSectionContainer>
  );
};
